// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// import classnames utility
import cx from 'classnames';

// import js utility
import _ from 'lodash';

import {validateField} from '../../../modelValidator';

// import material UI elements
import Divider from 'material-ui/Divider';

// import material UI elements with slightly modified source code
import MenuItem from '../c_SourceModMenuItem';
import DropDownMenu from '../c_SourceModDropDown';

import CloseX from '../../svgs/CloseX/index';


const menuCustomization = {
  autoWidth: false,
  labelStyle: {
    color: '#4a4a4a',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '16px',
    height: '48px'
  },
  listStyle: {
    backgroundColor: '#fafafa',
    fontWeight: 100,
    maxWidth: '384px' // remove from here later
  },
  selectedMenuItemStyle: {
    color: '#4a4a4a'
  },
  menuStyle: {
    backgroundColor: '#fafafa',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxWidth: '384px' // remove from here later
  },
  popoverStyle: {
    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
    maxWidth: '384px' // remove from here later
  }
};

const menuItemCustomization = {
  disableTouchRipple: true,
  disableFocusRipple: true,
  style: {
    transition: 'width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
  }
};


export default class CheckList extends Component {
  static propTypes = {
    defaultValue: PropTypes.any,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    validation: PropTypes.object,
    onErrorChange: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    menuItems: PropTypes.array.isRequired,
    className: PropTypes.string,
    scrollBarWidth: PropTypes.number,
    menuItemCustomization: PropTypes.object,
    containerStyle: PropTypes.object,
    floatingLabelText: PropTypes.string,
    floatingLabelStyle: PropTypes.object,
    canAutoPosition: PropTypes.bool,
    'data-id': PropTypes.string,
    showCount: PropTypes.bool,
    showLabel: PropTypes.bool,
    persistentLabel: PropTypes.string,
    optional: PropTypes.bool,
    errorText: PropTypes.string
  }

  static defaultProps = {
    menuItems: []
  }

  constructor(props, context) {
    super(props, context);

    // do this here because createHash needs to be available
    this.state = {
      checked: [],
      dirty: false,
      hash: this.createHash(),
      errors: []
    };
  }

  componentWillMount() {
    const initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : [];
    this.validate(initVal, initVal ? {checked: initVal} : {});
  }

  componentWillReceiveProps(nextProps) {

    if(this.props.menuItems !== nextProps.menuItems) {

      const hash = this.createHash();

      // If a checked item is not part of list. We remove it.
      const checked = _.intersection(Object.keys(hash).map(Number), this.state.checked);

      this.setState(_.assign(this.state, {hash, checked}));

    }

    if (this.props.value !== nextProps.value) {
      this.validate(nextProps.value, {checked: nextProps.value || [] });
    } else if (this.props.defaultValue !== nextProps.defaultValue) {
      this.validate(nextProps.defaultValue, {checked: nextProps.defaultValue || [] });
    }

  }

  componentWillUnmount() {
    if(this.state.errors.length && this.props.onErrorChange) {
      this.props.onErrorChange(-1);
    }
  }

  checkErrors() {
    if(!this.state.dirty) this.state.dirty = true; // set dirty if not already dirty
  }

  onChange(event, index, value) {

    if(!value) {
      return;
    }

    // off because of offsetting elements for checklist
    index = index - 4;

    const primaryText = this.props.menuItems[index].primaryText || value;

    const newCheckedArr = ~this.state.checked.indexOf(value) ?
      this.state.checked.filter(val => val !== value) :
      this.state.checked.concat(value);

    // handle validation update + this state change
    if(!this.props.hasOwnProperty('value')) {
      this.validate(newCheckedArr, {
        checked: newCheckedArr
      });
    } else {
      this.setState(_.assign(this.state, {
        checked: newCheckedArr
      }));
    }

    const returnValue = (newCheckedArr && newCheckedArr.length) ? newCheckedArr : null;
    if(this.props.onChange) {
      this.props.onChange(event, returnValue, primaryText, value);
    }

    if(this.props.onBlur) {
      this.props.onBlur(event, returnValue, primaryText, value);
    }
  }

  validate = (value, mergeObj) => {
    if(this.props.validation) {
      const errorsObj = {
        errors: validateField(value, this.props.validation)
      };
      if(errorsObj.errors.length !== this.state.errors.length) {
        if(this.props.onErrorChange) {
          this.props.onErrorChange(errorsObj.errors.length > this.state.errors ? 1 : -1);
        }
        this.setState(_.assign(this.state, errorsObj, mergeObj || {}));
      } else if (_.size(mergeObj)) {
        this.setState(_.assign(this.state, mergeObj));
      }
    } else if (_.size(mergeObj)) {
      this.setState(_.assign(this.state, mergeObj));
    }
  }

  createHash = () => {
    const hash = {};

    this.props.menuItems.forEach(menuItem => {
      hash[menuItem.value || menuItem.id] = menuItem.primaryText || menuItem.name;
    });

    return hash;
  }

  closeTag(value) {
    // deal with all menuItem input types
    const index = this.props.menuItems.findIndex((menuItem, i) => (
      _.isNil(menuItem) ? menuItem :
      typeof menuItem !== 'object' ? menuItem :
      menuItem.hasOwnProperty('id') ? menuItem.id :
      menuItem.value
    ) === value);

    // trigger onChange to update view+state
    this.onChange(null, index + 4, value); // #theWorst, dealing with material-ui inconsistencies, +4 takes into account divider and stuff
  }

  render() {
    // take out properties that will be overwritten from 'this.props'
    const {
      className,
      onChange,  /* eslint no-unused-vars:0 */
      onBlur,    /* eslint no-unused-vars:0 */
      scrollBarWidth,
      menuItemCustomization: propsMenuItemCustomization,
      'data-id': dataId,
      containerStyle,
      floatingLabelText,
      floatingLabelStyle,
      canAutoPosition,
      showCount,
      showLabel,
      ... unmodifiedProps
    } = this.props;

    const additionalProps = {
      onChange: ::this.onChange
    };

    // to be displayed in label
    let labelText = '';

    // if dropdown value is null (displaying 'Select') make text gray
    if(!this.state.checked || !this.state.checked.length || this.state.checked === 'null') {
      labelText = (showLabel) ? floatingLabelText : 'Select';

      additionalProps.labelStyle = _.merge({}, menuCustomization.labelStyle, {
        color: '#212326',
        fontWeight: 'normal'
      });
      additionalProps.menuStyle = _.merge({}, menuCustomization.menuStyle, {
        paddingRight: scrollBarWidth && `${scrollBarWidth}px` || '15px'
      });
    } else {
      if (this.props.showCount) {
        labelText = `${this.state.checked.length} Selected`;
      }
      else if (this.props.showLabel) {
        labelText = floatingLabelText;
      }
      else {
        labelText= `${this.state.checked.map(c => this.state.hash[c]).join(', ')}`;
      }
    }

    if (this.props.persistentLabel) {
      labelText = this.props.persistentLabel;
    }

    const isError = this.state.dirty && (typeof this.props.errorText !== 'undefined' || this.state.errors.length); // check passed in error string and local state errors array, only show if value is dirty

    if(isError) {
      additionalProps.labelStyle = _.merge({}, menuCustomization.labelStyle, {
        color: 'rgb(244, 67, 54)'
      });
    }

    const checkedList = (!_.isNil(this.state.checked) &&
                         !_.isEmpty(this.state.checked) &&
                         (this.state.checked !== 'null'))
                         ?
                         this.state.checked :
                         []
    ;

    return (
      <div className={cx('clearfix', 'dropdown-wrapper checklist-wrapper', className, {disabled: this.props.disabled, optional: this.props.optional, error: isError})} style={containerStyle}>
        {
          floatingLabelText && !showLabel
          &&
          <div className='floatingLabelText' data-id={`${dataId} floatingLabelText`} style={floatingLabelStyle || {}}>
            {floatingLabelText}
          </div>
        }
        <DropDownMenu className={cx('dropdown', {disabled: this.props.disabled})}
                      canAutoPosition
                      checkList
                      value={null}
                      data-id={dataId}
                      {...menuCustomization}
                      {...unmodifiedProps}
                      {...additionalProps}>
          <MenuItem value={null}
                    primaryText={labelText}
                    className='checklist-header'
                    {...menuItemCustomization}
                    {...propsMenuItemCustomization}
                    style={{backgroundColor: 'transparent', cursor: 'default'}}/>
          <Divider className='divider'/>
          <div className='checked-tags-container'>
            {
              checkedList.map((val, index) =>
                <div className='checked-tag-container' key={index}>
                  <div className='checked-tag'>
                    {this.state.hash[val]}
                    <CloseX
                      className='checked-tag-item'
                      data-id={`${val} Tag`}
                      onClick={this.closeTag.bind(this, val)}
                      style={
                        {
                          strokeWidth: 1,
                          color: '#4a4a4a',
                          marginLeft: '5px',
                          width: '10px',
                          height: '10px'
                        }
                      }
                    />
                  </div>
                </div>
              )
            }
          </div>
          <Divider className='divider'/>
          {
            this.props.menuItems
              .filter(item => item.hasOwnProperty('hide') ? !item.hide : true)
              .map((val, index) => {
              if(typeof val === 'undefined') {
                return undefined;
              }

              let value = '';
              let primaryText = '';
              if(val === null) {
                value = null;
                primaryText = 'Select';
              } else if(typeof val === 'string' || typeof val === 'number') {
                value = primaryText = val;
              } else {
                value = val.value || val.id;
                primaryText = val.primaryText || val.name;
              }

              return (
                <MenuItem checkBox
                          checked={!!~this.state.checked.indexOf(value)}
                          value={value}
                          primaryText={primaryText}
                          key={index}
                          data-id={primaryText}
                          {...menuItemCustomization}
                          {...propsMenuItemCustomization}/>
              );
            })
          }
        </DropDownMenu>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_CheckList/index.js